import { merge } from 'lodash-es';

export default {
    props: {
        translations: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        l10n() {
            return merge({}, this.$attrs, this.$props, this.$props.translations);
        },
    },
};
